import { render, staticRenderFns } from "./AdditionalInsuranceData.vue?vue&type=template&id=90d11b3c&scoped=true"
import script from "./AdditionalInsuranceData.vue?vue&type=script&lang=js"
export * from "./AdditionalInsuranceData.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInsuranceData.vue?vue&type=style&index=0&id=90d11b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d11b3c",
  null
  
)

export default component.exports